'use client';
import { responsiveModifierSet, isValidStyleProperty, isResponsiveModifier, getKey } from './swan-style.utils.js';
import { iterToSet } from './transform.utils.js';

function getClassName(key, value, modifier = 'xs') {
    if (value === undefined || value === null) {
        return null;
    }
    const effectiveKey = getKey(key);
    if (!effectiveKey) return null;
    const prefix = `swan-${effectiveKey}`;
    const suffix = modifier === 'xs' ? '' : `-${modifier}`;
    switch(typeof value){
        case 'boolean':
            return value ? prefix + suffix : null;
        default:
            return prefix + `-${value}` + suffix;
    }
}
function updateClassNameSet(key, value, modifier, classNamesSet) {
    const cname = getClassName(key, value, modifier);
    if (cname) {
        classNamesSet.add(cname);
    }
    return classNamesSet;
}
function processResponsiveStyleProps(props, defaultResponsiveModifier, classNameSet = new Set()) {
    Object.keys(props).forEach((propKey)=>{
        if (!isValidStyleProperty(propKey)) {
            return null // exit iteration
            ;
        }
        if (typeof props[propKey] === 'object') {
            // Key must be a modifier
            const responsiveValue = props[propKey];
            // eg: {xs: 1, md: 2}
            Object.keys(responsiveValue).forEach((modifier)=>{
                if (isResponsiveModifier(modifier)) {
                    updateClassNameSet(propKey, responsiveValue[modifier], modifier, classNameSet);
                }
            });
        } else {
            updateClassNameSet(propKey, props[propKey], defaultResponsiveModifier, classNameSet);
        }
    });
    return classNameSet;
}
function processStyleProps(props, defaultClassNameSet) {
    let classNameSet = iterToSet(defaultClassNameSet);
    if (props.swanStyle) {
        const swanStyle = props.swanStyle;
        responsiveModifierSet.forEach((modifier)=>{
            const modifierValue = swanStyle[modifier];
            if (modifierValue) {
                classNameSet = processResponsiveStyleProps(modifierValue, modifier, classNameSet);
            }
        });
        // This only process top level ResponsiveProps, inside Swan Style
        classNameSet = processResponsiveStyleProps(props.swanStyle, 'xs', classNameSet);
    }
    // This only process top level ResponsiveProps
    processResponsiveStyleProps(props, 'xs', classNameSet);
    return classNameSet;
}

export { processStyleProps };
